'use client';

import { usePathname, useRouter } from '@/i18n/routing';
import { cn } from '@/utils';
import { Button } from '@tajdid/tajdid-ui';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import React from 'react';

export type FilterTabProps<T> = {
  menus: {
    name: React.ReactNode;
    meta?: number | string;
    key: string;
    value: T;
  }[];
};

export default function FilterTab<T extends string>({
  menus,
}: FilterTabProps<T>) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathName = usePathname();
  const t = useTranslations();

  const isActive = (key: string, value: string) => {
    return searchParams.get(key) === value;
  };

  return (
    <div className="flex flex-wrap mb-6 gap-x-8">
      {menus.map((menu, index) => (
        <Button
          key={menu.value}
          variant="ghost"
          className={cn(
            'px-0',
            isActive(menu.key, menu.value) ||
              (index === 0 && searchParams.size === 0)
              ? 'text-primary underline underline-offset-8 max-xs:text-sm'
              : 'text-gray-500 max-xs:text-sm',
          )}
          onClick={() => {
            router.push(pathName + '?' + menu.key + '=' + menu.value);
          }}
        >
          {t(menu.name)}
          {menu.meta != null && (
            <span className="ml-2 block py-[2px] rounded bg-gray-100 text-[12px]">
              {menu.meta}
            </span>
          )}
        </Button>
      ))}
    </div>
  );
}
